<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!contract">
      <span class="loader"></span>
    </span>
    <contract-form
      v-if="contract"
      :loading="loading"
      :contractData="contract"
      :formErrors="formErrors"
      :only-charges="onlyCharges"
      @contractSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
      @cancelEdition="cancelEdition"
    />
  </div>
</template>

<script>
import ContractForm from "../partials/ContractForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { ContractForm },

  mixins: [alertLeave],

  props: {
    contractId: {
      type: [String, Number],
      required: true,
    },
    onlyCharges: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      contract: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    cancelEdition() {
      this.$emit("cancelEdition");
    },
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("contracts/get", this.contractId);
        this.contract =
          this.$store.getters["contracts/contract"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(contract) {
      this.loading = true;
      const contractData = cloneDeep(contract);

      try {
        await this.$store.dispatch("contracts/update", contractData);
        this.$notify({
          type: "success",
          message: this.$t("CONTRACTS.CONTRACT_UPDATED"),
        });
        const contract = await this.$store.getters[
          "contracts/contract"
        ];
        this.$emit("onViewContract", contract, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
